import React, { forwardRef, useImperativeHandle, useState } from "react";

import InputText from "@app/components/2_widgets/inputs/InputText";
import { useTranslation } from "react-i18next";
import SelectList from "@app/components/2_widgets/SelectList";

const ContractStructureDataRow = forwardRef(function ContractStructureDataRow({structureData}, ref) {
    const { t } = useTranslation();

    const kVAOptions = [
        {label: t("word.normal_rate_36"), value: "normal_rate_36"},                
        {label: t("word.normal_rate_36_250"), value: "normal_rate_36_250"},
        {label: t("word.normal_rate_250"), value: "normal_rate_250"}
    ]

    const [eligibilityValue, setEligibilityValue] = useState(structureData?.eligibility_value);
    const [kvaPower, setKvaPower] = useState(kVAOptions.find((d) => d.value == structureData?.kva_power));    
    
    useImperativeHandle(ref, ()=>({
        getStructureData() {
            return structureData;
        },
        getEligibilityValue() {
            return eligibilityValue;
        },
        getKvaPower() {
            return kvaPower?.value;
        }
    }));

    const structure = structureData.structure;

    function onChange(option) {
        setKvaPower(option);
    }
    
    return (
        <tr>
            <td key="1">
                <strong>{structure.trade_name}</strong>
                <br/>
                <span className="light-text">{structure.plm_number}</span>
            </td>
            <td key="2">
                <div className="custom-input-group-percentage">
                    <input 
                        className="form-control custom-form-control"
                        placeholder="100"
                        defaultValue={structureData.eligibility_value}
                        onChange={(event) => setEligibilityValue(event.target.value)}
                    />
                    <span>%</span>
                </div>
            </td>
            <td>
                <SelectList
                    options={kVAOptions}
                    placeholder=""
                    defaultValues={kvaPower}
                    callbackOnChange={onChange}
                />
            </td>
        </tr>
    )
})

export default ContractStructureDataRow;